/* ORALUX ™ — section interactions */
(function(){
  function ready(fn){if(document.readyState!='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}

  /* ---- scroll to buy-box / quantity selector for every CTA ---- */
  function scrollToBuy(){
    var t=document.querySelector('.quantity-break')||document.querySelector('quantity-breaks')||
          document.querySelector('.product-form__buttons')||document.querySelector('product-form')||
          document.querySelector('#MainProduct-'+ (window.__orlMain||''))||
          document.querySelector('[id^="MainProduct-"]');
    if(!t)return;
    var hdr=document.querySelector('.section-header, header[role="banner"], sticky-header, #shopify-section-sections--header, .shopify-section-header');
    var off=hdr?Math.min(hdr.getBoundingClientRect().height||0,90):0;
    var y=t.getBoundingClientRect().top+window.pageYOffset-off-14;
    window.scrollTo({top:y,behavior:'smooth'});
  }
  ready(function(){
    document.addEventListener('click',function(e){
      var b=e.target.closest('[data-orl-scroll]');
      if(b){e.preventDefault();scrollToBuy();}
    });

    /* ---- S03 before/after carousel ---- */
    document.querySelectorAll('[data-orl-ba]').forEach(function(root){
      var slides=root.querySelectorAll('.orl-ba-slide');var cards=root.querySelectorAll('.orl-ba-card');
      var i=0;var n=slides.length;
      function show(k){i=(k+n)%n;slides.forEach(function(s,x){s.style.display=x===i?'block':'none';});
        cards.forEach(function(c,x){c.style.display=x===i?'block':'none';});
        var cc=root.querySelector('[data-orl-ba-count]');if(cc)cc.textContent=(i+1)+' / '+n;
        var cc2=root.querySelector('[data-orl-ba-frac]');if(cc2)cc2.textContent='0'+(i+1)+' / 0'+n;}
      root.querySelectorAll('[data-orl-ba-prev]').forEach(function(el){el.onclick=function(){show(i-1);};});
      root.querySelectorAll('[data-orl-ba-next]').forEach(function(el){el.onclick=function(){show(i+1);};});
      /* drag divider */
      slides.forEach(function(s){
        var after=s.querySelector('.orl-ba-after');var div=s.querySelector('.orl-ba-div');var h=s.querySelector('.orl-ba-handle');
        if(!after)return;var box=s.querySelector('.orl-ba-imgs');var drag=false;
        function move(px){var r=box.getBoundingClientRect();var p=Math.max(4,Math.min(96,(px-r.left)/r.width*100));
          after.style.clipPath='inset(0 0 0 '+p+'%)';div.style.left=p+'%';if(h)h.style.left=p+'%';}
        function dn(e){drag=true;move((e.touches?e.touches[0]:e).clientX);}
        function mv(e){if(drag)move((e.touches?e.touches[0]:e).clientX);}
        function up(){drag=false;}
        box.addEventListener('mousedown',dn);window.addEventListener('mousemove',mv);window.addEventListener('mouseup',up);
        box.addEventListener('touchstart',dn,{passive:true});box.addEventListener('touchmove',mv,{passive:true});box.addEventListener('touchend',up);
      });
      show(0);
    });

    /* ---- rails (S04, S07): touch/swipe native + mouse drag-to-scroll ---- */
    document.querySelectorAll('[data-orl-rail]').forEach(function(root){
      var rail=root.querySelector('.rail');if(!rail)return;
      /* optional arrows if present */
      function step(){var c=rail.querySelector(':scope > *');return c?c.getBoundingClientRect().width+18:320;}
      root.querySelectorAll('[data-orl-rail-prev]').forEach(function(el){el.onclick=function(){rail.scrollBy({left:-step(),behavior:'smooth'});};});
      root.querySelectorAll('[data-orl-rail-next]').forEach(function(el){el.onclick=function(){rail.scrollBy({left:step(),behavior:'smooth'});};});
      /* mouse drag-to-scroll (desktop) */
      var down=false,sx=0,sl=0,moved=false;
      rail.addEventListener('mousedown',function(e){down=true;moved=false;sx=e.pageX;sl=rail.scrollLeft;rail.classList.add('orl-grab');});
      window.addEventListener('mousemove',function(e){if(!down)return;var d=e.pageX-sx;if(Math.abs(d)>4)moved=true;rail.scrollLeft=sl-d;});
      window.addEventListener('mouseup',function(){down=false;rail.classList.remove('orl-grab');});
      rail.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();}},true);
      rail.addEventListener('dragstart',function(e){e.preventDefault();});
    });

    /* ---- S06 wavelength accordion ---- */
    document.querySelectorAll('.orl-s06 .wl-head').forEach(function(h){
      h.onclick=function(){h.closest('.wl').classList.toggle('open');};
    });

    /* ---- S09 feature read-more ---- */
    document.querySelectorAll('.orl-s09 .f-more,.orl-s09 .f-close').forEach(function(b){
      b.onclick=function(){b.closest('.feat').classList.toggle('open');};
    });

    /* ---- S01b video controls (autoplay-in-view muted loop + mute/play toggles, like original) ---- */
    document.querySelectorAll('.orl-s01b [data-orl-vcard]').forEach(function(card){
      var v=card.querySelector('video');
      var mute=card.querySelector('[data-orl-vmute]');
      if(!v){ return; } /* no video: buttons inert, poster stays */
      var userPaused=false;
      function sync(){
        card.classList.toggle('playing', !v.paused);
        if(mute) mute.innerHTML = v.muted ? '&#128264;' : '&#128266;'; /* 🔇 / 🔊 */
        card.querySelectorAll('[data-orl-vplay]').forEach(function(p){
          if(p.classList.contains('play')) p.innerHTML = v.paused ? '&#9658;' : '&#10074;&#10074;';
        });
      }
      card.querySelectorAll('[data-orl-vplay]').forEach(function(p){
        p.addEventListener('click',function(e){e.preventDefault();
          if(v.paused){ userPaused=false; v.play().catch(function(){}); }
          else { userPaused=true; v.pause(); }
        });
      });
      if(mute) mute.addEventListener('click',function(e){e.preventDefault();
        v.muted=!v.muted; if(!v.muted && v.paused){ userPaused=false; v.play().catch(function(){}); } sync();});
      v.addEventListener('play',sync); v.addEventListener('pause',sync);
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){es.forEach(function(en){
          if(en.isIntersecting){ if(!userPaused) v.play().catch(function(){}); }
          else if(v.muted && !v.paused){ v.pause(); }
        });},{threshold:0.01, rootMargin:"0px 0px -10% 0px"}).observe(card);
      }
      sync();
    });

    /* ---- S13 review show more ---- */
    document.querySelectorAll('[data-orl-more]').forEach(function(b){
      b.onclick=function(){var w=b.closest('.orl-s13');w.querySelectorAll('.rhidden').forEach(function(r){r.classList.remove('rhidden');});b.style.display='none';};
    });
  });
})();
